<template>
	<Row v-if="showPendingAlerts" class="inbox-pending-alerts flex-centerize">
		<h5 class="inbox-pending-alerts-text">{{ numberOfRelevantAlerts }}</h5>
	</Row>
</template>
<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { STATIC_INBOXES_IDS } from '@/components/Inbox/inbox.const.js';
import { useAmountOfUnreadAlertsPerInboxId } from '@/store/modules/alerts/getters';
export default {
	name: 'InboxPendingAlerts',
	props: {
		id: { type: [String, Number] },
	},
	computed: {
		...mapGettersShorthand({ useAmountOfUnreadAlertsPerInboxId }),
		numberOfRelevantAlerts() {
			return this.useAmountOfUnreadAlertsPerInboxId(this.id);
		},
		showPendingAlerts() {
			return !this.isMainSharedInbox && this.numberOfRelevantAlerts > 0;
		},
		isMainSharedInbox() {
			return this.id === STATIC_INBOXES_IDS.SHARED_INBOX_ID;
		},
	},
};
</script>

<style scoped lang="scss">
.inbox-pending-alerts {
	width: 30px;
	height: 20px;
	border-radius: 10px;
	background: var(--white);
	border: 1px solid #dfdfe2;

	.inbox-pending-alerts-text {
		color: #3a404b;
	}
}
</style>
